import { CAlert, CButton, CCard, CCardBody, CCardHeader } from "@coreui/react";
import { useParams, Link } from "react-router-dom";
import { fetchJob, useJobRunStatus, useRunJob } from "./services/JobsServices";
import "./jobs-style.scss";
import React, { useState, useEffect } from "react";
import { JobRunLogsModal } from "./JobRunLogsModal";
import { Loading } from "src/reusable/LoadingSpinner";
import DialogueRefText from "./DialogueRefText";

const JobsRun = () => {
  const { job_id: jobId } = useParams();
  const [jobRunId, setJobRunId] = useState(null);
  const [job, setJob] = useState(false);
  const [showLogs, setShowLogs] = useState(false);

  const { mutate: runJob, isLoading: isRunJobLoading } = useRunJob(setJobRunId);

  const refetchInterval = 3000;
  const { data: jobRunStatus } = useJobRunStatus(jobRunId, refetchInterval);

  useEffect(() => {
    fetchJob(jobId).then((data) => setJob(data));
  }, []);

  return (
    <div
      style={{
        marginTop: "-10px",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: "8px",
      }}
    >
      <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row" }}>
        <>
          <CCard style={{ margin: "10px 8px", padding: 10, width: "100%" }}>
            <CCardHeader style={{ padding: "5px 5px" }}>
              <h5>Job Run</h5>
            </CCardHeader>
            <CCardBody
              style={{
                minWidth: 150,
                marginTop: 10,
                padding: "5px 5px",
                maxWidth: "400px",
              }}
            >
              <b>Name:</b> {job && job.name}
              <br />
              <b>Type:</b> {job && job.job_type.description}
              <br />
              <br />
              {jobRunId === null ? (
                <>
                  <CButton
                    data-attr="jobs:btn:start-job"
                    color="success"
                    onClick={() => {
                      runJob(jobId);
                    }}
                    style={{
                      width: "100px",
                    }}
                  >
                    {isRunJobLoading ? (
                      <Loading height={"20px"} width={"20px"} />
                    ) : (
                      "Start Job"
                    )}
                  </CButton>
                  <Link
                    to={`/jobs/${jobId}/viewer`}
                    data-attr="jobs:link:view-previous-runs"
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    <CButton color="info" size={"md"}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          justifyContent: "center",
                        }}
                      >
                        Previous runs
                      </div>
                    </CButton>
                  </Link>
                  <Link
                    to={`/jobs/${jobId}/job-schedule`}
                    data-attr="jobs:link:view-job-schedules"
                  >
                    <CButton color="info" size={"md"}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          justifyContent: "center",
                        }}
                      >
                        Job Schedules
                      </div>
                    </CButton>
                  </Link>
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    marginTop: "6px",
                  }}
                >
                  <div style={{ width: "100%", marginTop: "5px" }}>
                    <b>Job Run ID:</b> {jobRunId}
                  </div>
                  <div style={{ width: "100%", marginTop: "5px" }}>
                    <b>Job Start Time:</b> {jobRunStatus?.create_date}
                  </div>
                  <div style={{ width: "100%", marginTop: "5px" }}>
                    <div
                      style={{
                        float: "left",
                      }}
                    >
                      <b>Status:</b>{" "}
                    </div>
                    <div
                      className="job-run-status"
                      // display this div floating to the right of the status text
                      style={{
                        float: "left",
                        backgroundColor:
                          jobRunStatus?.status === "pending"
                            ? "grey"
                            : jobRunStatus?.status === "running"
                              ? "grey"
                              : jobRunStatus?.status === "success"
                                ? "#2eb85c"
                                : jobRunStatus?.status === "failed"
                                  ? "#e55353"
                                  : jobRunStatus?.status === "cancelled"
                                    ? "#636f83"
                                    : "grey",
                      }}
                    >
                      {jobRunStatus ? jobRunStatus.status : "pending"}
                    </div>
                  </div>
                  {jobRunStatus?.message && (
                    <div style={{ width: "100%", marginTop: "5px" }}>
                      {/* Agent runs carry a message in every state (live
                          progress, success one-liner) — color by status
                          instead of always rendering a red error alert. */}
                      <CAlert
                        color={
                          jobRunStatus?.status === "failed"
                            ? "danger"
                            : jobRunStatus?.status === "success"
                              ? "success"
                              : "info"
                        }
                      >
                        <DialogueRefText
                          text={jobRunStatus.message}
                          testId="jobs-run-status-dialogue-link"
                        />
                      </CAlert>
                    </div>
                  )}
                  {jobRunStatus?.finish_date && (
                    <div style={{ width: "100%", marginTop: "5px" }}>
                      <b>Job Finish Time:</b> {jobRunStatus?.finish_date}
                    </div>
                  )}
                  <div style={{ width: "100%", marginTop: "20px" }}>
                    <CButton
                      color="primary"
                      data-testid="job-logs-view-btn"
                      data-attr="jobs:btn:view-logs"
                      onClick={() => setShowLogs(true)}
                    >
                      View Logs
                    </CButton>
                    <JobRunLogsModal
                      isVisible={showLogs}
                      onClose={() => setShowLogs(false)}
                      jobRunId={jobRunId}
                    />
                  </div>
                </div>
              )}
              <br />
            </CCardBody>
          </CCard>
        </>
      </div>
    </div>
  );
};

JobsRun.propTypes = {};

export default JobsRun;
